import { render, staticRenderFns } from "./MarketingCards.vue?vue&type=template&id=65053678"
import script from "./MarketingCards.vue?vue&type=script&lang=js"
export * from "./MarketingCards.vue?vue&type=script&lang=js"
import style0 from "./MarketingCards.vue?vue&type=style&index=0&id=65053678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports